const LOAD_OUTAGES = {
  BEGIN: "LOAD_OUTAGES_BEGIN",
  SUCCESS: "LOAD_OUTAGES_SUCCESS",
  FAILURE: "LOAD_OUTAGES_FAILURE"
};

const UPDATE_OUTAGES = {
  BEGIN: "UPDATE_OUTAGES_BEGIN",
  SUCCESS: "UPDATE_OUTAGES_SUCCESS",
  FAILURE: "UPDATE_OUTAGES_FAILURE"
};

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_OUTAGES.SUCCESS:
      return action.payload.reduce((acc, outage) => {
        acc[outage.id] = outage;
        return acc;
      }, {});
    case UPDATE_OUTAGES.SUCCESS: {
      const { id } = action.payload;
      state = { ...state, [id]: action.payload };
      return state;
    }
    default:
      return state;
  }
}

export const loadOutages = () => {
  return {
    types: [LOAD_OUTAGES.BEGIN, LOAD_OUTAGES.SUCCESS, LOAD_OUTAGES.FAILURE],
    api: api => api.getOutages()
  };
};

export const updateOutages = (application, body) => {
  return {
    types: [
      UPDATE_OUTAGES.BEGIN,
      UPDATE_OUTAGES.SUCCESS,
      UPDATE_OUTAGES.FAILURE
    ],
    api: api => api.updateOutages(application, body)
  };
};
